import axios from "axios";

export default class PassengerBySpaceService {
  static getPassengerBySpace(space_id, passenger_id, cruise_id) {
    var url = "spacePassengers/" + space_id + "/passenger/" + passenger_id;
    if (cruise_id) {
      url = url + "?cruise_id=" + cruise_id;
    }
    return axios.get(url);
  }

  static postPassengerBySpace(booking_id, space_id, payload) {
    return axios.post("spacePassengers/"+ booking_id +"/" + space_id, payload);
  }

  static putPassengerBySpace(booking_id, space_id, passenger_id, payload) {
    return axios.put("spacePassengers/" + booking_id +"/"+space_id + "/passenger/" + passenger_id, payload);
  }

  static deletePassengerBySpace(space_id, passenger_id, spacePassenger_id) {
    return axios.delete(`spacePassengers/${space_id}/passenger/${passenger_id}/${spacePassenger_id}`);
  }

  static verifyPassengerBySpace(identification) {
    return axios.get("spacePassengers/" + identification + "/verify");
  }
}
